import { customAxiosInstance } from './mutator';

export interface GenerateMagicRolePromptCommand {
  text?: string;
  instructions?: string;
  name?: string;
  language?: string;
}

export const rolesGenerateMagicRolePrompt = (command: GenerateMagicRolePromptCommand) => {
  return customAxiosInstance<string>({
    url: '/api/Roles/GenerateMagicRolePrompt',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: command
  });
};
